export const LOCATION_TYPES = {
    whiteGlove: 'White Glove',
    curbside: 'Curbside',
    firstDrySpace: 'First Dry Space',
    roomOfChoice: 'Room of Choice',
    dock: 'Dock',
    inStore: 'In Store',
    rollUpDoor: 'Warehouse',
};
